import {AsyncPipe} from '@angular/common';
import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CheckoutCoreRegistererService} from 'src/app/shared/services/checkout-core/checkout-core-registerer.service';

@Component({
    selector: 'app-checkout-wc-wrapper',
    templateUrl: './checkout-wc-wrapper.component.html',
    styleUrl: './checkout-wc-wrapper.component.scss',
    standalone: true,
    imports: [AsyncPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CheckoutWcWrapperComponent {
    public readonly coreWebComponentPayload$ = this.checkoutCoreService.coreWebComponentPayload$;

    constructor(private checkoutCoreService: CheckoutCoreRegistererService) {}
}
